<template>
  <div id="company-display-overview" class="row d-flex flex-wrap justify-content-center">
    <div id="left" class="p-0 d-flex flex-column align-items-center justify-content-between" :class="company.summary ? 'col-5' : 'col'">
      <CompanyImage :url="company.logoLink" />
      <OverviewAddress :company="company" />
      <OverviewSocialIcons :company="company" />
    </div>

    <div v-if="company.summary || categoriesOffered.length > 0" id="right" class="col d-flex flex-column justify-content-between">
      <p class="text-secondary">
        {{ company.summary }}
      </p>
      <OverviewCategoriesOffered :categories="categoriesOffered" />
    </div>
  </div>
</template>

<script>
import OverviewAddress from "./overview/OverviewAddress.vue";
import OverviewSocialIcons from "./overview/OverviewSocialIcons.vue";
import OverviewCategoriesOffered from "./overview/OverviewCategoriesOffered.vue";
import CompanyImage from "./common/CompanyImage.vue";

export default {
  components: {
    OverviewAddress,
    OverviewSocialIcons,
    OverviewCategoriesOffered,
    CompanyImage,
  },
  props: {
    company: { type: Object, require: true },
  },
  data() {
    return {};
  },
  computed: {
    categoriesOffered() {
      return this.company.categories_offered || [];
    },
    companyImage() {
      if (this.company.logoLink.includes("gravatar")) {
        return "/img/icons/no-company.png";
      }
      return this.company.logoLink;
    },
  },
  mounted() {},
};
</script>

<style lang="scss" scoped>
#company-display-overview {
  padding: 1rem;

  #left {
    min-width: 20rem;
  }

  #right {
    min-width: 20rem;
    p {
      font-size: 1.3rem;
    }
  }
}
</style>
